// extracted by mini-css-extract-plugin
export default {"search":"press-secretaries_search__ufykM","field":"press-secretaries_field__BHMJv","list":"press-secretaries_list__ZyYs6"};